import Vue from 'vue/dist/vue.esm.js';
import gsap from 'gsap';

let parent = document.getElementById('#faqWrapper');
// DUMMY DATA
let data = [
  {
    headline: 'Who is a good candidate for breast reduction surgery?',
    description: 'The best candidates for breast reduction surgery are healthy people who have large breasts (the medical term is “macromastia”), and whose breasts are causing them to experience negative symptoms such as backpain , or rashes beneath the breasts.',
  },
  {
    headline: 'Who is a good candidate for breast reduction surgery?',
    description: 'The best candidates for breast reduction surgery are healthy people who have large breasts (the medical term is “macromastia”), and whose breasts are causing them to experience negative symptoms such as backpain , or rashes beneath the breasts.',
  },
  {
    headline: 'Who is a good candidate for breast reduction surgery?',
    description: 'The best candidates for breast reduction surgery are healthy people who have large breasts (the medical term is “macromastia”), and whose breasts are causing them to experience negative symptoms such as backpain , or rashes beneath the breasts.',
  },
  {
    headline: 'Who is a good candidate for breast reduction surgery?',
    description: 'The best candidates for breast reduction surgery are healthy people who have large breasts (the medical term is “macromastia”), and whose breasts are causing them to experience negative symptoms such as backpain , or rashes beneath the breasts.',
  },
  {
    headline: 'Who is a good candidate for breast reduction surgery?',
    description: 'The best candidates for breast reduction surgery are healthy people who have large breasts (the medical term is “macromastia”), and whose breasts are causing them to experience negative symptoms such as backpain , or rashes beneath the breasts.',
  },
  {
    headline: 'Who is a good candidate for breast reduction surgery?',
    description: 'The best candidates for breast reduction surgery are healthy people who have large breasts (the medical term is “macromastia”), and whose breasts are causing them to experience negative symptoms such as backpain , or rashes beneath the breasts.',
  },
]

Vue.component('faq', {
  props: {
    elements: {
      type: Array,
      required: true,
      default: ()=>{
        return data;
      }
    }
  },
  mounted(){
  },
  methods: {
    toggleActive: function(event){

    }
  }
});

new Vue({}).$mount('#faqWrapper');
